// extracted by mini-css-extract-plugin
export default {"main":"PetTrainer_main__RVlG3","formDiv":"PetTrainer_formDiv__XnxTJ","form":"PetTrainer_form__HWQA2","input":"PetTrainer_input__TyZNi","select":"PetTrainer_select__Qw6LJ"};